<div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Promociones de Proyecto: <strong> {{ project.name }} </strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <h6>
            <span *ngIf="promotionFiles" > <mat-icon class="align-middle">update</mat-icon> Última actualización: <strong>{{ promotionFiles[0].created_at | date : "dd/MM/yyyy hh:mma": "-0000" }} {{ " - " + promotionFiles[0].user }}</strong></span>
        </h6>
        <h6 class="pb-4">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <span class="">Lista de Archivos de Promociones</span>
            <div class="d-flex align-items-center gap-2 flex-wrap">
                <!-- <mat-form-field appearance="outline" class="compact-field custom-search-field" >
                    <mat-label>Columnas Visibles</mat-label>
                    <mat-select [(ngModel)]="selectedColumns" (blur)="updateColumnas()" #selectRef multiple>
                        <button  mat-flat-button (click)="toggleSelectAllMedia(selected_columns)"><mat-icon>library_add</mat-icon>Seleccionar/Quitar todos los medios</button>
                        <mat-option *ngFor="let u of displayedColumns" [value]="u">{{ u }}</mat-option>
                    </mat-select>
                </mat-form-field> -->

                
                <a *ngIf="promotionFiles" href="{{promotionFiles[0]?.url}}" target="_blank" mat-stroked-button color="primary">Descarga último archivo <mat-icon class="align-middle ms-2">file_download</mat-icon></a>
               <!--<button *ngIf="promotionFiles" mat-flat-button color="primary" class="ms-2" (click)="openDialogPromoEdit()">Editar archivo
                    <mat-icon>edit</mat-icon>
                </button>--> 
                <button mat-flat-button color="primary" class="ms-2" (click)="openDialogUploadDistFile()">Subir archivo
                    <mat-icon>upload_file</mat-icon>
                </button>

                <button *ngIf="promotionFiles && hasPermissions('super_promo',null,true)"  mat-flat-button color="primary" class="ms-2" (click)="openConfig()">Configuración
                    <mat-icon>settings</mat-icon>
                </button>
            </div>
            </div>
        </h6>        
        <mat-divider></mat-divider>
        <div>
            <div class="row g-2">
                <div class="col mb-0">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Archivo</th>
                                    <th>Responsable</th>
                                    <th>Fecha de Registro</th>
                                    <th>Equipo</th>
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let file of promotionFiles">
                                    <td>
                                        {{ file.id }}
                                    </td>
                                    <td>
                                        <a href="{{ file.url }}" target="_blank">
                                            {{ file.name }}
                                        </a>
                                    </td>
                                    <td>
                                        {{ file.user }}
                                    </td>
                                    <td>
                                        {{ file.created_at | date : "dd/MM/yyyy hh:mma": "-0000" }}
                                    </td>
                                    <td>
                                        <span class="badge {{file.id_rol==3?'bg-info':'bg-warning'}}">{{file.rol}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>